import applicantDemographicsSaga from 'ApplicationEntry/sagas/applicantDemographicsSaga';
import AWDStatusSaga from 'ApplicationEntry/sagas/AWDStatusSaga';
import billingAgentSaga from 'ApplicationEntry/sagas/billingAgentSaga';
import cancerSaga from 'ApplicationEntry/sagas/cancerSaga';
import caseDetailsSaga from 'ApplicationEntry/sagas/caseDetailsSaga';
import criticalIllnessSaga from 'ApplicationEntry/sagas/criticalIllnessSaga';
import disabilitySaga from 'ApplicationEntry/sagas/disabilitySaga';
import lifeProductsSaga from 'ApplicationEntry/sagas/lifeProductsSaga';
import policyDetailsSaga from 'ApplicationEntry/sagas/policyDetailsSaga';
import saveToLife70Saga from 'ApplicationEntry/sagas/saveToLife70Saga';
import shopSaga from 'ApplicationEntry/sagas/shopSaga';
import qualitySaga from 'ApplicationEntry/sagas/qualitySaga';
import UWQuestionSaga from 'ApplicationEntry/sagas/UnderwritingQuestionsSaga';
import verifyCriticalInformationSaga from 'ApplicationEntry/sagas/verifyCriticalInformationSaga';
import {all} from 'redux-saga/effects';
import AWDLoginSaga from './AWDLoginSaga';
import workQueueSaga from './workQueueSaga';
import pinCareSaga from './pinCareSaga';
import accidentSaga from './accidentSaga';
import aipSaga from './aipSaga';

export default function*() {
  yield all([
    applicantDemographicsSaga(),
    AWDLoginSaga(),
    workQueueSaga(),
    cancerSaga(),
    pinCareSaga(),
    accidentSaga(),
    caseDetailsSaga(),
    policyDetailsSaga(),
    billingAgentSaga(),
    criticalIllnessSaga(),
    AWDStatusSaga(),
    verifyCriticalInformationSaga(),
    saveToLife70Saga(),
    disabilitySaga(),
    UWQuestionSaga(),
    lifeProductsSaga(),
    shopSaga(),
    qualitySaga(),
    aipSaga(),
  ]);
}
